import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.909 2.247v-.56a.75.75 0 1 0-1.5 0v.56h-1.66v-.56a.75.75 0 1 0-1.5 0v.56h-1.66v-.56a.75.75 0 0 0-1.5 0v.56A2.757 2.757 0 0 0 1.469 5v6.45a2.755 2.755 0 0 0 2.75 2.75h7.56a2.748 2.748 0 0 0 2.75-2.75V5a2.75 2.75 0 0 0-2.62-2.753Zm1.12 9.2a1.25 1.25 0 0 1-1.25 1.25h-7.56a1.25 1.25 0 0 1-1.25-1.25V5a1.224 1.224 0 0 1 1.12-1.23v.53a.75.75 0 0 0 1.5 0v-.55h1.66v.55a.75.75 0 0 0 1.5 0v-.55h1.66v.55a.75.75 0 0 0 1.5 0v-.53A1.224 1.224 0 0 1 13.029 5Zm-2.41-5.18v1.5h-5.24v-1.5Zm-1.31 2.39v1.5h-3.93v-1.5Z';
const draw24px =
  'M17.83,4.1h-.25V2.85a.75.75,0,0,0-1.5,0V4.1H12.75V2.85a.75.75,0,1,0-1.5,0V4.1H7.92V2.85a.75.75,0,1,0-1.5,0V4.1H6.16A3.75,3.75,0,0,0,2.41,7.85v10a3.76,3.76,0,0,0,3.75,3.75H17.83a3.76,3.76,0,0,0,3.75-3.75v-10A3.75,3.75,0,0,0,17.83,4.1Zm2.25,13.74a2.25,2.25,0,0,1-2.25,2.25H6.16a2.25,2.25,0,0,1-2.25-2.25v-10A2.25,2.25,0,0,1,6.16,5.6h.26V6.85a.75.75,0,0,0,1.5,0V5.6h3.33V6.85a.75.75,0,1,0,1.5,0V5.6h3.33V6.85a.75.75,0,1,0,1.5,0V5.6h.25a2.25,2.25,0,0,1,2.25,2.25ZM16,11.75H8v-1.5h8Zm-2,3.66H8v-1.5h6Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const NotepadIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'notepad'),
) as IconWithRender;

NotepadIcon.displayName = 'NotepadIcon';
NotepadIcon.propTypes = Icon.propTypes;
NotepadIcon.renderIcon = (props) => <NotepadIcon {...props} />;
export default NotepadIcon;
